import { createContext, FC, PropsWithChildren, useContext } from 'react';
import { Socket } from 'socket.io-client';

import { clientConfig } from '@/config/clientConfig';

import { useSocketConnection } from './useSocketConnection';

const CaseSocketContext = createContext<Socket | null>(null);

export const useCaseSocket = () => {
  return useContext(CaseSocketContext);
};

export const CaseSocketProvider: FC<PropsWithChildren> = ({ children }) => {
  const socket = useSocketConnection({
    url: clientConfig.socketUrls.case,
    namespace: 'Case',
  });

  return <CaseSocketContext.Provider value={socket}>{children}</CaseSocketContext.Provider>;
};
